(() => {
  function setupProductTabs(root) {
    if (!root || root.dataset.tabsReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    if (!tabs.length || !panels.length) return;

    root.dataset.tabsReady = 'true';

    function activateTab(tab) {
      tabs.forEach((item) => {
        const isActive = item === tab;
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
    }

    tabs.forEach((tab, index) => {
      tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;

      tab.addEventListener('click', () => {
        activateTab(tab);
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = index + 1 >= tabs.length ? 0 : index + 1;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = index - 1 < 0 ? tabs.length - 1 : index - 1;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });
  }

  function setupAllProductTabs() {
    document.querySelectorAll('[data-product-tabs]').forEach(setupProductTabs);
  }

  setupAllProductTabs();
  document.addEventListener('DOMContentLoaded', setupAllProductTabs);
  document.addEventListener('shopify:section:load', setupAllProductTabs);
})();
